<template lang="pug">
.container.content(v-if="contents && contents.length")
	.columns
		.column
			iFrameVideo(v-if="videoType.value === 'url'" :video="video")
			YouTube(v-if="videoType.value === 'youtube'" :video="video")
			Vimeo(v-if="videoType.value === 'vimeo'" :video="video")
			VimeoLiveStream(v-if="videoType.value === 'vimeo_stream'" :video="video")
		.column
			Heading(v-if="heading" :heading="heading.title" :subHeading="heading.sub_title")
			div(v-if="textContent && textContent.text" v-html="textContent.text" :class="{ 'column is-offset-1 is-10': videoPosition === 'top-block' }")
</template>
<script>
import _ from 'lodash'

import Heading from './Partials/Heading'
import iFrameVideo from './Partials/iFrameVideo'
import YouTube from './Partials/YouTube'
import Vimeo from './Partials/Vimeo'
import VimeoLiveStream from './Partials/VimeoLiveStream'

export default {
	name: "Video",
	components: {
		Heading,
		YouTube,
		Vimeo,
		VimeoLiveStream,
		iFrameVideo
    },
	data() {
		return {
			
		}
	},
	props: {
		section: {
            type: Object,
            required: true,
        },
	},
	computed: {
		contents() {
            return this.section.contents || []
        },
        heading() {
            return this.contents.find(content => content.key === 'heading')
        },
        textContent() {
            return this.contents.find(content => content.key === 'text')
        },
        video() {
            return this.contents.find(content => content.key === 'video')
        },
        videoSettings() {
        	return this.video.settings || []
        },
        videoType() {
        	return this.videoSettings.find(setting => setting.key === 'type')
        },
        videoPosition() {
            let position = 'left-float'

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'video_position')
                if (setting && setting.value !== undefined) position = setting.value
            }

            return position
        },
	},
	methods: {
		
	}
}
</script>
<style lang="sass" scoped>
</style>